import { render, staticRenderFns } from "./DetailCurrency.vue?vue&type=template&id=bad48f40"
import script from "./DetailCurrency.vue?vue&type=script&lang=js"
export * from "./DetailCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports